<template>
  <div class="flex justify-between items-center mt-4">
    <Button
      v-if="showBack"
      variant="ghost"
      :disabled="loading"
      @click="emit('back')"
    >
      Back
    </Button>
    <div v-else />
    <Button
      v-if="isLastStep"
      color="primary"
      :loading="loading"
      :disabled="!canProceed || loading"
      @click="handleSubmit"
    >
      {{ submitText }}
    </Button>
    <Button
      v-else
      color="primary"
      :disabled="!canProceed || loading"
      @click="emit('next')"
    >
      Continue
    </Button>
  </div>
</template>

<script setup lang="ts">
defineProps({
  showBack: {
    type: Boolean,
    default: true
  },
  isLastStep: {
    type: Boolean,
    default: false
  },
  canProceed: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  submitText: {
    type: String,
    default: 'Submit'
  }
})
const emit = defineEmits(['next', 'back', 'submit'])
const handleSubmit = () => {
  emit('submit')
}
</script>
